import { ApiModerationRoutes, CreateReportRequest } from '@foxbun/lib-goferal-types';
import { BaseApiClient } from '../base/BaseApiClient';

export class ModerationClient extends BaseApiClient {
  report(req: CreateReportRequest) {
    return this.post({
      path: ApiModerationRoutes.REPORT,
      req: CreateReportRequest,
      params: req
    });
  }
}
